module.exports = __webpack_public_path__ + "static/logo-pcmag-5dd677dc807844e0a3b422ab8abc5e76.png";